document.addEventListener('DOMContentLoaded', function () {
  const dataEl = document.querySelector('[data-style-items]');
  const track = document.querySelector('[data-video-track]');
  if (!dataEl || !track) return;

  const base = JSON.parse(dataEl.textContent);
  const n = base.length;
  const REPS = 5;
  let items = [];
  for (let r = 0; r < REPS; r++) items = items.concat(base);
  let active = Math.floor(items.length / 2);
  active = active - (active % n) + Math.floor(n / 2);

  function render() {
    track.innerHTML = items
      .map((it, i) => {
        const isActive = i === active;
        const mediaTag = isActive
          ? `<video src="${it.video}" poster="${it.img}" autoplay muted loop playsinline></video>`
          : `<img src="${it.img}" alt="${it.name} styling tutorial">`;
        return `
        <div class="video-slide ${isActive ? 'is-active' : ''}" data-i="${i}">
          <div class="media">
            ${mediaTag}
            <div class="scrim-white"></div>
            <div class="play-badge"><svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="11" fill="rgba(0,0,0,.25)"/><path d="M10 8l6 4-6 4V8z" fill="#fff"/></svg></div>
          </div>
          <div class="style-card">
            <img class="style-thumb" src="${it.smallImg || it.img}" alt="${it.name}">
            <div class="style-text">
              <div class="style-name">${it.name}</div>
              ${it.color ? `<div class="style-color">${it.color}</div>` : ''}
              <div class="style-price">${it.price}</div>
            </div>
          </div>
        </div>`;
      })
      .join('');
    centerActive();
    // The `autoplay` attribute on a <video> built via an innerHTML string isn't reliably
    // honored by every browser the way it is for markup present at initial page parse —
    // same root cause fixed in assets/ig-grid.js. Explicitly starting playback covers that
    // gap on every render() call (initial load, click-to-switch, and recenter).
    const activeVideo = track.querySelector('.video-slide.is-active video');
    if (activeVideo) activeVideo.play().catch(() => {});
    track.querySelectorAll('.video-slide').forEach((s) => {
      s.addEventListener('click', () => {
        const i = parseInt(s.dataset.i, 10);

        // Enlarge-on-click (lightbox) is intentionally disabled for these clips —
        // clicking a slide only ever switches/centers it, never opens the lightbox.
        if (i === active) return;
        active = i;
        render();
        recenterIfNeeded();
      });
    });
  }

  function stepActive(dir) {
    active += dir;
    render();
    recenterIfNeeded();
  }

  function recenterIfNeeded() {
    const margin = n;
    if (active < margin || active > items.length - 1 - margin) {
      const cyclePos = active % n;
      const mid = Math.floor(items.length / 2);
      active = mid - (mid % n) + cyclePos;
      track.style.transition = 'none';
      render();
      requestAnimationFrame(() => {
        track.style.transition = '';
      });
    }
  }

  function centerActive() {
    const slide = track.children[active];
    if (!slide) return;
    const wrapW = track.parentElement.offsetWidth;
    const target = slide.offsetLeft - wrapW / 2 + slide.offsetWidth / 2;
    track.style.transform = `translateX(-${target}px)`;
  }

  // SISCODE: `resize` also fires from things that have nothing to do with the user actually
  // resizing the window — most commonly, mobile browsers collapsing/expanding their address
  // bar as the page is scrolled (exactly the moment this carousel's own IntersectionObserver,
  // 600px below, is mounting it). Reusing `centerActive()`'s plain `track.style.transform`
  // write for that meant every such event replayed the CSS `transition: transform` on
  // .video-track — visible as the carousel "scrolling a few [slides] by itself" right as it
  // scrolled into view, even though nothing about the active slide had changed. A resize-
  // driven recompute is a corrective width fix, not a navigation — it should snap instantly,
  // never animate — and rapid-fire resize events (several in a row during one scroll gesture)
  // should coalesce into a single recompute instead of stacking transform writes.
  let resizeRaf = null;
  window.addEventListener('resize', () => {
    if (resizeRaf) return;
    resizeRaf = requestAnimationFrame(() => {
      resizeRaf = null;
      const prevTransition = track.style.transition;
      track.style.transition = 'none';
      centerActive();
      track.offsetHeight;
      track.style.transition = prevTransition;
    });
  });

  /* Swipe left/right to step to the next/previous video (touch devices only — mouse
     drag isn't handled, matching how the rest of the site treats desktop vs mobile). */
  const wrap = track.parentElement;
  let touchStartX = 0;
  let touchStartY = 0;
  let touchMoved = false;

  wrap.addEventListener(
    'touchstart',
    (e) => {
      const t = e.touches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
      touchMoved = false;
    },
    { passive: true }
  );

  wrap.addEventListener(
    'touchmove',
    () => {
      touchMoved = true;
    },
    { passive: true }
  );

  wrap.addEventListener(
    'touchend',
    (e) => {
      if (!touchMoved) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;
      const SWIPE_THRESHOLD = 40;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        stepActive(dx < 0 ? 1 : -1);
      }
    },
    { passive: true }
  );

  // The section's active slide autoplays a real (often multi-megabyte HD) video, so — same
  // fix already applied to assets/ig-grid.js and assets/made-for-every-occasion.js — it's only
  // built and started once the section is about to scroll into view, instead of unconditionally
  // on every page load regardless of scroll position. This was the one carousel of the three
  // that never got this gate: its active video was measured loading immediately on page load,
  // taking 25+ seconds on a real connection because of it.
  const styleSection = document.querySelector('.style-section');
  if (styleSection && 'IntersectionObserver' in window) {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          render();
          sectionObserver.disconnect();
        }
      },
      { rootMargin: '600px 0px' }
    );
    sectionObserver.observe(styleSection);
  } else {
    render();
  }
});
